import axios from "./axios";

class TestimonialRepository {
  getTestimonials(count) {
    const url = count ? `/testimonials?count=${count}` : `/testimonials`;
    return axios
      .get(url)
      .then((response) => {
        if (count) return response.data[Object.keys(response.data)[0]];
        else return response.data;
      })
      .catch((error) => console.log(error));
  }

  get(id) {
    return axios
      .get(`/testimonials/${id}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => console.log(error));
  }

  create(test) {
    return axios.post(`/testimonials`, test).then((response) => {
      return response.data;
    });
  }

  update(test) {
    return axios.put(`/testimonials/${test.id}`, test).then((response) => {
      return response.data;
    });
  }

  save(test) {
    if (!test.id) return this.create(test);
    else return this.update(test);
  }

  remove(test) {
    return axios.delete(`/testimonials/${test.id}`);
  }
}

export default new TestimonialRepository();



// WEBPACK FOOTER //
// ./src/data/testimonial.repository.js